import { render, staticRenderFns } from "./SwitchCompany.vue?vue&type=template&id=e9b4f60c&scoped=true"
import script from "./SwitchCompany.vue?vue&type=script&lang=js"
export * from "./SwitchCompany.vue?vue&type=script&lang=js"
import style0 from "./SwitchCompany.vue?vue&type=style&index=0&id=e9b4f60c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b4f60c",
  null
  
)

export default component.exports